import styled from 'styled-components';
import { motion } from 'framer-motion';
import { SHIPMENT_CARD_MARGIN_BOTTOM } from '@/modules/pmt/constants';

export const AnimateListWrapper = styled(motion.div)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[SHIPMENT_CARD_MARGIN_BOTTOM],
}));
